import React, { useEffect, useState } from "react";
import AddPassword from "../../components/forgetPassword/AddPassword";

import { Box, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import { resetTokenVerfication } from "../../services/user/UserServices";
import { useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import "./changePassword.scss";

const ForgetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isValidToken, setIsValidToken] = useState(false);
  const params = location.search.split(/=/);
  const email = params[1].split("&")[0];
  const token = params[params.length - 1];
  async function checkIsTokenValid() {
    setIsValidToken(true);
    const payLoad = {
      email: email,
      resetPasswordToken: token,
    };
    const result = await resetTokenVerfication(payLoad);
    if (result.success) {
      setIsValidToken(false);
    } else {
      navigate("/link-expired");
    }
  }
  useEffect(() => {
    checkIsTokenValid();
  }, []);
  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        className="register-page"
      >
        <Grid
          container
          direction="column"
          marginTop="3rem"
          padding="1rem"
          width="30%"
          className="main-div"
        >
          {isValidToken ? (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Circles color="#dfc8db" height={80} width={80} />
            </Box>
          ) : (
            <AddPassword values={{ email, token }} />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ForgetPassword;
